import React, { PropsWithChildren } from "react";
import {
  View,
  Platform,
  TextInput,
  StyleSheet,
  TextInputProps,
} from "react-native";
import Icon from "component/typography/Icon";
import Text from "component/typography/Text";
import ImgIcon from "component/typography/ImageIcon";

import { sizes, colors } from "asset/constant";
import { priceFormatter } from "utils";
import fonts from "asset/fonts";
import { useSN } from "hook";

const Input = (
  props: PropsWithChildren<
    TextInputT & { imageIcon?: ImageIconT } & TextInputProps
  >
) => {
  const {
    lang = "fa",
    icon,
    imageIcon,
    style,
    error,
    value,
    inputRef,
    hideError,
    leftComponent,
    enablePriceFormatter,
    onChange,
  } = props;

  const sn = useSN();

  return (
    <>
      <View style={{ ...styles.container, ...style }}>
        <View
          style={{
            height: sn(48, 48, 43, 43),
            ...styles.leftComponentContainer,
          }}
        >
          {leftComponent}
        </View>
        <View style={{ ...styles.inputContainer, height: sn(48, 48, 43, 43) }}>
          {enablePriceFormatter && (
            <View style={styles.priceViewSection}>
              <Text>{priceFormatter(value)}</Text>
            </View>
          )}
          <TextInput
            ref={inputRef}
            {...(props as TextInputProps)}
            multiline={Platform.OS === "android" && !props.secureTextEntry}
            numberOfLines={1}
            blurOnSubmit={true}
            returnKeyType={"done"}
            value={value}
            placeholderTextColor={colors.text.placeholder}
            style={{
              ...styles.input,
              borderRadius: sizes.radius.lg,
              fontSize: 14,
              fontFamily: lang ? fonts[lang].bold : fonts.fa.bold,
              ...(enablePriceFormatter && {
                color: colors.transparent,
                letterSpacing: 1,
              }),
            }}
          />
        </View>

        {(icon || imageIcon) && (
          <View style={styles.iconContainer}>
            {icon && <Icon size={20} {...icon} />}
            {imageIcon && <ImgIcon size={30} {...imageIcon} />}
          </View>
        )}
      </View>
      {!hideError && (
        <View style={styles.errorContainer}>
          <Text size={"xs"} color={colors.danger}>
            {error}
          </Text>
        </View>
      )}
    </>
  );
};

export default Input;

const styles = StyleSheet.create({
  container: {
    width: "100%",
    borderWidth: 2,
    overflow: "hidden",
    flexDirection: "row",
    justifyContent: "flex-end",
    borderRadius: sizes.radius.lg,
    borderColor: colors.border.normal,
    backgroundColor: colors.bg.element,
  },

  inputContainer: { flex: 1, overflow: "hidden" },

  iconContainer: {
    width: 45,
    alignItems: "center",
    justifyContent: "center",
  },

  labelContainer: {
    width: "100%",
    alignItems: "flex-end",
  },

  input: {
    zIndex: 1000,
    flex: 1,
    fontSize: 14,
    textAlign: "right",
    paddingHorizontal: 2,
    marginBottom: 0,
    marginTop: 0,
    paddingBottom: 0,
    paddingTop: 0,
    color: colors.text.normal,
    textAlignVertical: "center",
    ...(Platform.OS === "web" && { outlineColor: colors.transparent }),
  },

  priceViewSection: {
    width: "100%",
    height: "100%",
    position: "absolute",
    justifyContent: "center",
    paddingHorizontal: 5,
  },

  errorContainer: {
    width: "100%",
    alignSelf: "flex-end",
    height: 20,
    paddingHorizontal: 5,
    bottom: Platform.OS === "web" ? -2 : 3,
  },

  leftComponentContainer: {
    justifyContent: "center",
  },
});
